var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex w-full justify-between" }, [
    _c(
      "div",
      [
        !_vm.posting.active
          ? _c("Badge", {
              class: _vm.badgeData.class,
              attrs: { color: _vm.badgeData.color, value: _vm.badgeData.value },
            })
          : _c("Badge", {
              class: _vm.badgeData.class,
              attrs: { color: _vm.badgeData.color, value: _vm.badgeData.value },
            }),
      ],
      1
    ),
    _vm.canEdit
      ? _c(
          "div",
          { staticClass: "flex gap-2" },
          [
            _vm.processing
              ? _c("span", [true ? _c("Spinner") : _vm._e()], 1)
              : [
                  !_vm.posting.active
                    ? _c("EyeIcon", {
                        staticClass: "cursor-pointer",
                        attrs: { width: "17", height: "17", stroke: "#717986" },
                        nativeOn: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleToggleActiveness.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      })
                    : _c("EyeOffIcon", {
                        staticClass: "cursor-pointer",
                        attrs: { width: "17", height: "17", stroke: "#717986" },
                        nativeOn: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleToggleActiveness.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      }),
                ],
            _c("EditPenIcon", {
              staticClass: "cursor-pointer",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onEdit.apply(null, arguments)
                },
              },
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }